import React, { useState } from 'react';

import { useSelector } from 'react-redux'

import { useObjectSelector, getObject, useNestedObjectSelector, getNestedObject, useNestedNestedObjectSelector, getNestedNestedObject,  } from '../redux/hooks'
import { update } from '../redux/reducers'

import { useDispatch } from 'react-redux'

import Review from '../compObjects/Review';


function ReviewExisting(props) {

    const dispatch=useDispatch()

    const objectId = "/api/reviews/" + props.reviewId + "/"
    const reviewSelector = useObjectSelector(objectId)
    const review = getObject(objectId, reviewSelector, dispatch)
    const movieSelector = useNestedObjectSelector(objectId, (review) => "/api/movies/" + review.movie)
    const movie = getNestedObject(review, () => "/api/movies/" + review().movie, movieSelector, dispatch)
    const profileSelector = useNestedObjectSelector(objectId, (review) => "/api/profiles/" + review.profile)
    const profile = getNestedObject(review, () => "/api/profiles/" + review().profile, profileSelector, dispatch)
    const profileThumbSelector = useNestedNestedObjectSelector(objectId, (review) => "/api/profiles/" + review.profile, (profile) => "/api/images/" + profile.thumbnail)
    const profileThumb = getNestedNestedObject(profile, () => "/api/images/" + profile().thumbnail, profileThumbSelector, dispatch)


    const [objectInputState, setObjectInputState] = useState()

    const startEdit = () => {
        setObjectInputState(review())
        setEditState("EDIT")
    }

    const [editState, setEditState] = useState('READ') //EDIT ; 
    const [updateConclusionState, setUpdateConclusionState] = useState('NONE')  

    const startSave = () => {
        dispatch(update(objectId, objectInputState, (result)=>{
            console.log("callback ! result : "+JSON.stringify(result))
            setUpdateConclusionState(result)
            if (result.status==="fulfilled") 
                setEditState("READ")
        }))
        setUpdateConclusionState("UPDATEPENDING")
    }

    const startCancel = () => {
        setUpdateConclusionState("NONE")
        setEditState("READ")
    }

    const loginState = useSelector(store => store.loginReducer)

    return (
        editState === "READ" ?
            <Review
                type={props.type}

                review={review}
                movie={movie}
                profile={profile}
                //movieThumb={movieThumb}
                profileThumb={profileThumb}

                editState={editState}
                updateConclusionState={updateConclusionState}

                modifiable={review().profile!=="UNKNOWN" && loginState.logged && loginState.profile.id === review().profile}

                startEdit={startEdit}
            />

            :
   
            <Review
                type={props.type}

                objectInputState={objectInputState}
                setObjectInputState={setObjectInputState}

                editState={editState}
                updateConclusionState={updateConclusionState}

                startSave={startSave}
                startCancel={startCancel}

            />

    );
}

export default ReviewExisting;